import React from 'react';
import classNames from 'classnames';
import Icon from "@scentregroup/ui/components/icon";
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const IconRow = ({
  text,
  className,
  icon
}) => /*#__PURE__*/_jsxs("div", {
  className: classNames(style.location, className),
  children: [icon && /*#__PURE__*/_jsx(Icon, {
    type: icon,
    size: "small",
    className: style.pinIcon
  }), text]
});

export default IconRow;